import { render } from "./EditorProfile.vue?vue&type=template&id=22a1866b"
import script from "./EditorProfile.vue?vue&type=script&lang=js"
export * from "./EditorProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__